export const getXShareLink = (link: string) => {
  return `https://x.com/intent/post?url=${encodeURIComponent(link)}`;
};
